<lib-dba-mat-dialog-title (cancelClick)="dialogRef.close()">
  @if(data.mode=='create'){
  {{language.safetypointerstellen | translationPipe}}
  }@else{
  {{language.safetypointbearbeiten | translationPipe}}
  }
</lib-dba-mat-dialog-title>

<mat-dialog-content [formGroup]="FormGroup">
  @if(loading){<lib-spinner-dialog></lib-spinner-dialog>}

  <lib-select-create formControlName="debitorControl" [selectList]="debitorList" selectValue="DebitorID"
    [selectNameList]="['Nummer','Name','PLZ','Ort','LandName']" [label]="language.debitor | translationPipe"
    [showDeselect]="false" [showCreate]="false" [required]="true">
  </lib-select-create>

  <lib-select-create formControlName="standortControl" [selectList]="getfilterStandortList()" selectValue="StandortID"
    [selectNameList]="['Bezeichnung']"  [showCreate]="permissionService.StandortSchreiben && FormGroup.controls['debitorControl'].value != null" 
    [createCallbackFunction]="OpenCreateStandortDialog"  [label]="language.Standort | translationPipe"
    [showDeselect]="true"  [(value)]="selectedstandortModelView" [required]="true">
  </lib-select-create>

  <lib-select-create formControlName="objektControl" [selectList]="getfilterObjektList()" selectValue="ObjektID"
    [selectNameList]="['Bezeichnung']"  [showCreate]="permissionService.ObjektSchreiben && FormGroup.controls['standortControl'].value != null"  
    [createCallbackFunction]="OpenCreateObjektDialog"  [label]="language.objekt | translationPipe" 
    [showDeselect]="true"  [(value)]="selectedobjektModelView" [required]="true">
  </lib-select-create>

  <lib-select-create formControlName="roofAreaControl" [selectList]="getfilterRoofareaList()" selectValue="RoofareaID"
    [selectNameList]="['Bezeichnung']" [showCreate]="permissionService.RoofareaSchreiben && FormGroup.controls['objektControl'].value != null"  
    [createCallbackFunction]="OpenCreateRoofareaDialog" [label]="language.roofarea | translationPipe" 
    [showDeselect]="true"  [(value)]="selectedroofareaModelView" [required]="true">
  </lib-select-create>

  <lib-select-create formControlName="sicherungssystemControl" [selectList]="getSicherungssysteme()" selectValue="SicherungssystemID"
    [selectNameList]="['Bezeichnung']"  [showCreate]="permissionService.SicherungssystemSchreiben && FormGroup.controls['roofAreaControl'].value != null"
    [createCallbackFunction]="OpenCreateSicherungssystemDialog" [label]="language.Sicherungssystem | translationPipe" 
    [showDeselect]="true" [(value)]="selectedsicherungssystemModelView" [required]="true">
  </lib-select-create>
  
  @if(withelectronicID)
  {
    <mat-form-field>
      <mat-label>{{language.ElectronicID | translationPipe}}</mat-label>
      <input matInput formControlName="electronicidControl">
    </mat-form-field>
  }
  @if(withassetlink)
  {
   <mat-form-field>
    <mat-label>{{ language.AssetLink | translationPipe }}</mat-label>

    <input
      matInput
      formControlName="assetlinkControl">

    @if (isValidUrl(assetLinkControl?.value)) {
      <button
        mat-icon-button
        matSuffix
        type="button"
        aria-label="Link öffnen"
        (click)="openLink(assetLinkControl?.value)">
        <mat-icon>public</mat-icon>
      </button>
    }
  </mat-form-field>
  }
  
  <mat-form-field>
    <mat-label>{{language.Bezeichnung | translationPipe}}</mat-label>
    <input matInput maxlength="100" formControlName="description">
  </mat-form-field>

  @if(withgeolocation)
  {
    <div class="row">
      <mat-form-field>
        <mat-label>{{language.Longitude | translationPipe}}</mat-label>
        <input type="number" matInput required formControlName="longitude" (blur)="formatLongitude()">
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{language.Latitude | translationPipe}}</mat-label>
        <input type="number" matInput required formControlName="latitude" (blur)="formatLatitude()">
        @if(this.LatitudeControl.value!=null && this.LongitudeControl.value!=null){
        <mat-icon (click)="openMaps()" matSuffix>public</mat-icon>
        }
      </mat-form-field>
    </div>
  }
  @if(widthformular)
  {
    <lib-select-create formControlName="form" [selectList]="formList" selectName="Name"
      [label]="language.Formular | translationPipe" [showCreate]="false" [(value)]="selectedForm">
    </lib-select-create>
  }
  
  <doc-documents [documentList]="documentList" [maxImageAmount]="4"></doc-documents>
  
</mat-dialog-content>

<mat-dialog-actions>
  <lib-dba-mat-dialog-footer (cancelClick)="dialogRef.close()" (saveClick)="Save()"></lib-dba-mat-dialog-footer>
</mat-dialog-actions>